import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, FlatList, useWindowDimensions } from 'react-native';
import { Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';
import { useTableHelper } from '../../../hooks/useTableHelper';


const FlatListView = React.memo(({ item, styles, t, convertDate, handleDelete,
    selectedCompany,
    modal, control, setValue, ActivityIndicator, index, medicalSchemeDropdown,
    insuranceCompanyDropdown, width
}) => {
    //#region Variables
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [startDateCalendar, setDoaCalendar] = useState([]);
    const [endDateCalendar, setDotCalendar] = useState([]);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pressed, setPressed] = useState();
    //#endregion

    //#region UseEffects
    useEffect(() => {
        const dateToSet = startDateCalendar?.startDate ? convertDate(startDateCalendar.startDate) : '';
        setValue(`${item?.ui}.startdate`, dateToSet);
    }, [startDateCalendar]);

    useEffect(() => {
        const dateToSet = endDateCalendar?.startDate ? convertDate(endDateCalendar.startDate) : '';
        setValue(`${item?.ui}.enddate`, dateToSet);
    }, [endDateCalendar]);

    useEffect(() => {
        let startdate = item?.startdate;
        if (startdate) {
            setDoaCalendar({ startDate: startdate });
        } else {
            setDoaCalendar({ startDate: '' });
        }

        let enddate = item?.enddate;
        if (enddate) {
            setDotCalendar({ startDate: enddate });
        } else {
            setDotCalendar({ startDate: '' });
        }
    }, []);
    //#endregion

    //#region Show / Hide
    const onShowCalendarPress = (btn) => {
        if (pressed === btn) {
            setPressed(null);
            setCalendarVisible(false);
            setShowCalendar(!showCalendar);
        }
        else {
            setPressed(btn);
            setCalendarVisible(true);
            setShowCalendar(true);
        }
    }

    const onShowAdditionalLocationInfoPress = (item) => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }
    //#endregion

    //#region Calendar
    const renderCalendar = () => {
        return (
            <SafeAreaView style={styles.secondLine}>
                {/* calendar view */}
                <View style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 10,
                    borderWidth: 0,
                    borderColor: colors.border_card,
                }}>
                    <CustomCalendar
                        calendarType={'RangePicker'}
                        setRange={pressed === 'startdate' ? setDoaCalendar : setDotCalendar}
                        range={pressed === 'startdate' ? startDateCalendar : endDateCalendar}
                        allowSingleDate={true}
                        startingYear={1990}
                    />
                </View>
            </SafeAreaView>
        )
    }
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <ActivityIndicator animating={true} />
        )
    //#endregion


    return (
        <SafeAreaView>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        <SafeAreaView style={styles.item}>
                            <CustomLabel value={t(`common:medScheme`)} type='SUBTITLENOFLEX' />
                            {/* <View style={{ justifyContent: 'center', alignItems: 'center' }}> */}
                            <CustomControlledDropdown
                                multipleSelect={true}
                                control={control}
                                name={`${item.ui}.code`}
                                type="TIMESHEET"
                                options={medicalSchemeDropdown}
                            />
                            {/* </View> */}
                        </SafeAreaView>
                        <View
                            style={[styles.item]}>
                            <CustomLabel value={t(`common:startDate`)} type='SUBTITLENOFLEX' />
                            <SafeAreaView style={styles.row}>
                                <CustomControlledInput
                                    name={`${item.ui}.startdate`}
                                    control={control}
                                    editable={false}
                                    type='EDIT_EMPLOYEE'
                                />
                                <Ionicons
                                    name={pressed === 'startdate' ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={() => onShowCalendarPress('startdate')}
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <CustomLabel value={t(`common:endDate`)} type='SUBTITLENOFLEX' />
                            <SafeAreaView style={styles.row}>
                                <CustomControlledInput
                                    name={`${item.ui}.enddate`}
                                    control={control}
                                    editable={false}
                                    type='EDIT_EMPLOYEE'
                                />
                                <Ionicons
                                    name={pressed === 'enddate' ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={() => onShowCalendarPress('enddate')}
                                />
                            </SafeAreaView>
                        </View>
                        <View style={styles.verticalLine} />
                        <SafeAreaView style={[{ flexDirection: width < 1300 ? 'column' : 'row' }]}>
                            <CustomButton
                                iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                onPress={() => {
                                    onShowAdditionalLocationInfoPress()
                                }}
                                text={t('common:additionalInfos')}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                            <CustomButton
                                iconName={"trash-outline"}
                                onPress={() => {
                                    handleDelete(item, index, 'ui', modal)
                                }}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.justMargin}></SafeAreaView>
                    </SafeAreaView>
                    {showAdditionalInformation &&
                        <SafeAreaView>
                            <SafeAreaView style={styles.row}>
                                <View
                                    style={[styles.item]}>
                                    <SafeAreaView>
                                        <CustomLabel value={t(`common:insuredPerson`)} type='SUBTITLENOFLEX' />
                                        <CustomControlledInput
                                            name={`${item.ui}.insuredperson`}
                                            control={control}
                                            editable={true}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </SafeAreaView>
                                </View>
                                <View
                                    style={[styles.item]}>
                                    <SafeAreaView>
                                        <CustomLabel value={t(`common:insuranceCo`)} type='SUBTITLENOFLEX' />
                                        <CustomControlledDropdown
                                            multipleSelect={true}
                                            control={control}
                                            name={`${item.ui}.insuranceco`}
                                            type="TIMESHEET"
                                            options={insuranceCompanyDropdown}
                                            setValue={setValue}
                                        />
                                    </SafeAreaView>
                                </View>
                            </SafeAreaView>
                            <SafeAreaView style={styles.row}>
                                <SafeAreaView style={styles.item}>
                                    <CustomLabel value={t('common:contributionOfEmployer')} type='SUBTITLENOFLEX' />
                                    <CustomControlledInput
                                        defaultValue={selectedCompany?.description}
                                        name={`${item.ui}.cocontr`}
                                        control={control}
                                        editable={true}
                                        type='EDIT_EMPLOYEE'
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.item}>
                                    <CustomLabel value={t('common:contributionOfEmployee')} type='SUBTITLENOFLEX' />
                                    <CustomControlledInput
                                        defaultValue={selectedCompany?.description}
                                        name={`${item.ui}.emplcontr`}
                                        control={control}
                                        editable={true}
                                        type='EDIT_EMPLOYEE'
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.item}>
                                    <CustomLabel value={t('common:number')} type='SUBTITLENOFLEX' />
                                    <CustomControlledInput
                                        defaultValue={selectedCompany?.description}
                                        name={`${item.ui}.number`}
                                        control={control}
                                        editable={true}
                                        type='EDIT_EMPLOYEE'
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                    {showCalendar && calendarVisible &&
                        renderCalendar()
                    }
                </SafeAreaView>
            </SafeAreaView>
        </SafeAreaView>
    )
})


const HRAdminMedicalScheme = ({ props }) => {
    //#region Variables
    const { medicalSchemeDropdowns, selectedEmployee, convertDate, styles,
        modal, t, modalVisible, setModalVisible, ActivityIndicator, colors, renameKeysInOptions, selectedCompany
    } = props;
    const { width, height } = useWindowDimensions();
    const [changes, setChanges] = useState([]);
    const {
        getMedicalScheme, getDropdownValues, insertMedicalScheme, updateMedicalScheme, deleteMedicalScheme
    } = useHRAdminEmployees();
    const [medicalSchemeDetails, setMedicalSchemeDetails] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [originalmedicalSchemeDetails, setOriginalMedicalSchemeDetails] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { handleCancelChanges, rowAdd, rowDelete, rowEdit } = useTableHelper();
    const { control, handleSubmit, formState: { errors }, setValue, unregister, register } = useForm();
    const [medicalSchemeDropdown, setMedicalSchemeDropdown] = useState([]);
    const [insuranceCompanyDropdown, setInsuranceCompanyDropdown] = useState([]);
    const sParams = [
        { InsuranceCo: { sFilt1: "", sFilt2: "", sFilt3: "" } },
        { MedicalScheme: { sFilt1: selectedEmployee?.employeeID, sFilt2: "", sFilt3: "" } }
    ];
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const ref = useRef(null);
    //#endregion

    //#region UseEffects
    useEffect(() => {
        setIsLoading(true);

        getDropdownValues(sParams).then((res) => {
            let insuranceCo = renameKeysInOptions(res?.InsuranceCo);
            let medicalDropdown = renameKeysInOptions(res?.MedicalScheme);
            setInsuranceCompanyDropdown(insuranceCo);
            setMedicalSchemeDropdown(medicalDropdown);
            getMedicalScheme(selectedEmployee?.employeeID).then((res) => {
                let medicalScheme = res?.data;
                console.log(medicalScheme)
                setMedicalSchemeDetails(medicalScheme);
                setOriginalMedicalSchemeDetails(medicalScheme);
                medicalScheme.forEach((item, index) => {
                    item['startdate'] = item?.startdate?.split('T')[0];
                    item['enddate'] = item?.enddate?.split('T')[0];
                    Object.keys(item).forEach(key => {
                        setValue(`${item.ui}.${key}`, item[key]);
                    });
                });
                setIsLoading(false);
            });
        })
    }, []);

    useEffect(() => {
        if (medicalSchemeDetails.length <= 0) return;
        let item = medicalSchemeDetails[0];
        Object.keys(item).forEach(key => {
            register(`${item.ui}.${key}`);
        });
    }, [medicalSchemeDetails, setValue]);

    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
                setState(null);
            }, 10000);
            return () => {
                clearTimeout(timer)
            };
        }
    }, [state]);
    //#endregion


    //#region Submit
    const onSubmit = data => {
        let remainingObjects = [];
        Object.keys(data).forEach((key, index) => {
            if (!insertData.includes(key) && !deletedItems.includes(key)) {
                remainingObjects.push(data[key]);
            }
        });
        insertData.forEach((ui, indexInsert) => {
            deletedItems.forEach((delUi, indexDelete) => {
                if (ui === delUi) {
                    insertData.splice(indexInsert, 1);
                    deletedItems.splice(indexDelete, 1);
                }
            });
        });
        const insertObjects = findObjects(data, insertData);
        return submitData(insertObjects, remainingObjects, deletedItems)
    };

    const submitData = async (insertData, updateData, deleteData) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;
        let employeeid = selectedEmployee?.employeeID;
        setState('saving');
        if (insertData.length > 0)
            newPromises.push(
                insertMedicalScheme(insertData, employeeid).then((res) => {
                    if (res?.status === 200) insertSucc = true;
                }).catch(() => { })
            )
        if (deleteData.length > 0)
            newPromises.push(
                deleteMedicalScheme(deleteData, employeeid).then((res) => {
                    if (res?.status === 200) deleteSucc = true;
                }).catch(() => { })
            )
        if (updateData.length > 0)
            newPromises.push(
                updateMedicalScheme(updateData, employeeid).then((res) => {
                    if (res?.status === 200)
                        updateSucc = true;
                }).catch(() => { })
            )
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        setState('deleteFailed');
                    }
                    else
                        setState('issueMessage');
                }
                else if (deleteSucc && updateSucc && insertSucc) {
                    setState('allOperationsSuccMess');
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    //#endregion

    //#region Helpers
    const findObjects = (mainObject, arr) => {
        return arr.map(ui => {
            const innerObject = mainObject[ui];
            if (innerObject) {
                return {
                    ...innerObject, ui,
                    employeeID: selectedEmployee?.employeeID,
                    company: selectedCompany?.code,
                };
            }
            return null;
        }).filter(item => item !== null);
    };
    //#endregion

    //#region Handlers
    const handleAddPress = () => {
        let exceptions = [];
        rowAdd(medicalSchemeDetails, setMedicalSchemeDetails, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'ui');
    };

    const handleRemovePress = () => {
        handleCancelChanges(setMedicalSchemeDetails, originalmedicalSchemeDetails, setDeletedItems, setChanges, setDuplicates);
    };

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, medicalSchemeDetails, setMedicalSchemeDetails, setDeletedItems, ref);
        unregister(`items.${item.ui}`);
    }
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion 

    //#region Render
    const renderItem = useCallback(({ item, index }) => {
        return (
            <Card
                style={[styles.cardStyleLocation]} >
                <Card.Content>
                    <FlatListView
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        medicalSchemeDropdowns={medicalSchemeDropdowns}
                        convertDate={convertDate}
                        handleDelete={handleDelete}
                        modal={modal}
                        setValue={setValue}
                        medicalSchemeDropdown={medicalSchemeDropdown}
                        insuranceCompanyDropdown={insuranceCompanyDropdown}
                        ActivityIndicator={ActivityIndicator}
                        width={width}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }, [medicalSchemeDetails]);
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion


    return (
        <>
            <View style={styles.iconRow}>
                <View style={styles.leftIcons}>
                    <Ionicons
                        name={"add-circle-outline"}
                        style={styles.icon}
                        onPress={handleAddPress}
                    />
                    <Ionicons
                        name={"remove-circle-outline"}
                        style={styles.icon}
                        onPress={handleRemovePress}
                    />
                </View>
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {state && showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type='EDIT_EMPLOYEE_STATE'
                    />}
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <FlatList
                style={{ height: height / 3, flexGrow: 0 }}
                data={medicalSchemeDetails}
                keyExtractor={(item, index) => `${item?.ui}`}
                renderItem={renderItem}
                scrollEnabled={true}
                refreshing={isLoading}
                ref={ref}
                initialNumToRender={10}
                ListHeaderComponent={
                    <CustomLabel
                        value={`${selectedEmployee?.name}'s ${t(`common:medicalSchemeTitle`)}`}
                        type='SUBTITLE'
                    />
                }
                ListEmptyComponent={
                    isLoading ? (
                        <ActivityIndicator animating={true} color={colors.blue} />
                    ) : (
                        <CustomLabel
                            value={t("common:salarySchemeLoadingPreview")}
                            type="NO_BRANCHES"
                        />
                    )
                }
            />
            <View style={[styles.functionalityButtons]}>
                <CustomButton
                    text={t('common:saveChanges')}
                    onPress={handleSubmit(onSubmit)}
                    type='BUTTON_SAVE'
                    textTop='0'
                    sz={15}
                />
            </View>
        </>
    );
};

export default HRAdminMedicalScheme;